import * as tslib_1 from "tslib";
import { selectFavoriteCategory } from 'owa-mail-folder-forest-actions';
export default function mailCategoryRouteHandler(parameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, selectFavoriteCategory(parameters.categoryId)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=mailCategoryRouteHandler.js.map